<template>
    <div id="topicsTab">
        <div class="search open-search">
            <div class="search-holder">
                <md-icon class="search-glass-icon">search</md-icon>
                <div class="search-field" v-if="topicsSelected">
                    <div class="md-input-focused md-input-container">
                        <GmapAutocomplete disabled v-model="autocompleteInput" ref="search" placeholder="" class="md-input" :bounds="bounds" @place_changed="newPlaceSelected"></GmapAutocomplete>
                    </div>
                    <div class="autocomplete-buttons">
                        <md-button @click="confirmDelete()" title="Delete Topic(s)" class="md-icon-button">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </div>
                </div>
                <div class="search-field" v-else>
                    <div class="md-input-focused md-input-container">
                        <GmapAutocomplete v-model="autocompleteInput" ref="search" placeholder="" class="md-input" :bounds="bounds" @place_changed="newPlaceSelected"></GmapAutocomplete>
                    </div>
                    <div class="autocomplete-buttons">
                        <span v-if="topicsSelected">
                            <md-button @click="confirmDelete()" title="Delete Topic(s)" class="md-icon-button">
                                <md-icon>delete</md-icon>
                            </md-button>
                        </span>
                        <span v-else>
                            <md-button class="md-icon-button" title="Add Topic" @click="addTopic">
                                <md-icon class="icon-add_circle"></md-icon>
                            </md-button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="scroll-list" id="scrollSize">
            <span v-bind:class="[{'checkbox' : checkTopicsinList()}, {'checkbox-disabled' : !checkTopicsinList()}]">
                <md-checkbox class="checkbox" v-model="selectAllTopics" type="checkbox" @change="toggleSelectAll($event)">Select All</md-checkbox>
            </span>
            <md-list class="img-list check-avatar selectable" id="topicsTabList">
                <span v-for="(topic, index) in topics">
                    <md-list-item @click="" v-bind:class="[{'items-active' : topicsSelected }, {'back-grey' : topic.mapHover }]" v-on:mouseover="hoverOn(index)" v-on:mouseleave="hoverOff(index)">
                        <div v-bind:class="[topic.selected ? 'item-selected' : 'item-unselected']" role="button">
                            <div class="avatar s-36 material-icons  material-icons-My" @click="toggleSelectedTopic(index)">
                                <span v-if="topic.selected">{{ topic.positionInitial }}</span>
                                <img v-else :src="getImageSrc(topic.avatar)"/>
                            </div>
                            <div @click="toggleExpand(index)" class="md-list-item-text">
                            <h3>{{ topic.name }}</h3>
                                <p id="topicAddress">{{ topic.address }}</p>
                            </div>
                        </div>
                    </md-list-item>
                </span>
            </md-list>
        </div>
        <footer class="aside-btn" v-if="vTopicCondition">
            <div class="btn-wrap">
                <md-button class="md-raised md-primary" @click="saveChanges">Save Topic Changes</md-button>
            </div>
        </footer>
        <footer class="aside-btn" v-else-if="topicsSelected">
            <div v-show="(routesList.length > 0)" class="btn-wrap" v-bind:class="{ 'add-btn': topicsSelected > 0 && (routesList.length > 0) }">
                <md-button class="md-raised md-primary" @click="showDialog = true">Add to Route</md-button>
            </div>
            <div class="btn-wrap" v-bind:class="{ 'add-btn': topicsSelected && (routesList.length > 0) }">
                <md-button class="md-raised md-primary" @click="createNewRoute">Create Route</md-button>
            </div>
        </footer>
        <md-dialog :md-active.sync="showDialog" class="small-modal addToRouteDialog">
            <header>
                <h2>Add to Route</h2>
                <md-button class="md-icon-button" @click="showDialog = false">
                    <md-icon>clear</md-icon>
                </md-button>
            </header>
            <md-list class="scroll-list">
                <md-list-item v-for="route in routesList" :key="route.id">
                    <button class="extraClass" @click="addTopicsToRoute(route)">{{ route.name }}</button>
                </md-list-item>
            </md-list>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                <div class="scroll-cont-wrap">
                    <md-list v-for="(routesName, key) in routesNames" :key="routesName">
                        <div v-if="key !== 'notAssigned'">
                            If you delete the TOPIC <b>'{{ key.toUpperCase() }}'</b>, it will be removed from:
                            <md-list v-for="routeName in routesName" :key="routeName">
                                <b> - {{ titleCase(routeName) }}</b>
                            </md-list>
                        </div>
                        <div v-if="key == 'notAssigned' && routesName.length!== 0">
                            The following will be removed from the list of TOPICS:
                            <md-list v-for="topicname in routesName" :key="topicname">
                                <b> - {{ topicname.toUpperCase() }}</b>
                            </md-list>
                        </div>
                    </md-list>
                </div>
                Do you want to continue with this delete request?
                <p class="instruction-delete"><b>o </b>To continue with the delete request, click DELETE. <br/><b>o </b>To stop the delete request, click CANCEL.</p>
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="clickDeleteTopics()">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import * as EditorServices from '../../services/EditorService.js';
import {deleteTopics, getRouteNames} from '../../services/TopicService.js';

export default {
  data: () => ({
    selectedTopics: [],
    selectedInput: {},
    autocompleteInput: '',
    showDialog: false,
    isLoadingmy: false,
    selectAllTopics: false,
    showDeleteDialog: false,
    routesNames: ''
  }),
  computed: {
    ...mapState({
      realTopics: state => state.map.topicsOfInterest,
      virtualTopics: state => state.map.virtualTopics,
      currentTour: state => state.tours.currentTour,
      vTopicCondition: state => state.topics.virtualTopicCondition,
      center: state => state.map.center
    }),
    ...mapGetters('routes', ['routesList']),
    ...mapGetters('topics', {topics: 'topicsList'}),
    ...mapGetters('map', ['bounds']),
    topicsSelected () {
      return this.selectedTopics.length > 0;
    }
  },
  methods: {
    ...mapActions('routes', ['insertNewRoute', 'insertNewRouteTopics']),
    ...mapActions('topics', ['loadTopics', 'toggleTopicHover', 'setTopicsList', 'reSortTopics']),
    ...mapActions('routes', ['loadRoutes']),
    toggleSelectedTopic (index) {
      this.topics[index].selected = !this.topics[index].selected;
      if (this.selectedTopics.includes(index)) {
        var selectedIndex = this.selectedTopics.indexOf(index);
        this.selectedTopics.splice(selectedIndex, 1);
      } else {
        this.selectedTopics.push(index);
      }
      this.checkAllSelected();
    },
    async confirmDelete () {
      let topicIds = this.getTopicIdsFromIndexes();
      let response = await getRouteNames(topicIds);
      this.routesNames = response.data;
      this.showDeleteDialog = true;
    },
    titleCase (str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },
    checkTopicsinList () {
      return this.topics.length > 0;
    },
    toggleSelectAll (event) {
      if (event === true) {
        for (let index of Object.keys(this.topics)) {
          if (!this.selectedTopics.includes(parseInt(index))) {
            this.topics[index].selected = true;
            this.selectedTopics.push(parseInt(index));
          }
        }
      } else {
        for (let topic of this.topics) {
          topic.selected = false;
        }
        this.selectedTopics = [];
      }
    },
    checkAllSelected () {
      if (this.selectedTopics.length === this.topics.length) {
        this.selectAllTopics = true;
      } else {
        this.selectAllTopics = false;
      }
    },
    hoverOn (index) {
      this.$bus.$emit('hoveredTopic', {topicIndex: index, toggle: true});
      this.toggleTopicHover({index: index, hover: true});
    },
    hoverOff (index) {
      this.$bus.$emit('hoveredTopic', {topicIndex: index, toggle: false});
      this.toggleTopicHover({index: index, hover: false});
    },
    getImageSrc (image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/' + image;
        } else {
          return image;
        }
      }
    },
    toggleExpand (index) {
      this.topics[index].expanded = !this.topics[index].expanded;
    },
    async addTopic () {
      if (this.$refs.search.$el.value.replace(/^\s+|\s+$/g, '').length > 0) {
        if (this.autocompleteInput === this.$refs.search.$el.value) {
          this.selectedInput.isReal = 1;
          this.$store.dispatch('map/setCenter', this.selectedInput);
          this.selectedInput.address = this.selectedInput.formatted_address;
          if (this.selectedInput.photos) {
            this.selectedInput.avatar = this.selectedInput.photos[0].getUrl({'maxWidth': 100, 'maxHeight': 100}).replace('w100-h100-k', 'k');
          } else {
            this.selectedInput.avatar = 'topic_default.png';
          }
        } else {
          this.selectedInput.isReal = 0;
          this.selectedInput.name = this.$refs.search.$el.value;
          this.selectedInput.latLng = {lat: this.center.lat, lng: this.center.lng};
          this.selectedInput.avatar = 'virtual_default.png';
        }
        if (this.topicUniqueCheck(this.selectedInput.name)) {
          var response = await EditorServices.newTopic(this.selectedInput);
          if (response.status === 200) {
            this.$refs.search.$el.value = '';
            this.selectedInput.id = response.data.id;
            this.selectedInput.selected = false;
            this.selectedInput.hover = false;
            this.selectedInput.mapHover = false;
            this.selectedInput.expanded = false;
            this.selectedInput.stories = [];
            this.topics.push(this.selectedInput);
            this.reSortTopics();
            this.selectedInput = {};
          } else {
            console.log(response);
          }
        }
      }
    },
    topicUniqueCheck (topicName) {
      let unique = true;
      for (let topic of this.topics) {
        if (topic.name.toLowerCase() === topicName.toLowerCase()) {
          unique = false;
        }
      }
      return unique;
    },
    newPlaceSelected (e) {
      this.autocompleteInput = this.$refs.search.$el.value;
      this.selectedInput = e;
      this.selectedInput.latLng = {lat: e.geometry.location.lat(), lng: e.geometry.location.lng()};
    },
    saveChanges () {
      EditorServices.updateTopics();
    },
    createNewRoute () {
      var routeTopics = this.getTopicIdsFromIndexes();
      var newRoute = {
        name: 'New ' + this.currentTour.city + ' Route',
        tourId: this.currentTour.id,
        vehicleId: null, // this should default to something or be selectable somehow (?)
        description: 'This is a new route.',
        avatar: null,
        channels: null,
        path: null,
        commentary: 0,
        notificationSound: 0,
        commentaryDelay: 1,
        audioControllerNotification: 0,
        audioControllerFlashTime: 2,
        headendSys: null,
        notificationSongId: null,
        routeTopics: routeTopics
      };
      this.insertNewRoute(newRoute).then(() => {
        this.$router.push('/tour/route');
      });
    },
    addTopicsToRoute (route) {
      var topicsToAdd = this.getTopicIdsFromIndexes();
      this.insertNewRouteTopics({route: route, newTopics: topicsToAdd}).then(() => {
        this.$router.push('/tour/route');
      });
    },
    async clickDeleteTopics () {
      let topicIds = this.getTopicIdsFromIndexes();
      const response = await deleteTopics(topicIds);
      if (response.status === 200) {
        this.selectedTopics = [];
        var forCheckthis = this;
        this.loadTopics(this.currentTour.id).then((data) => {
          forCheckthis.loadRoutes(forCheckthis.currentTour.id);
        });
        this.showDeleteDialog = false;
      }
    },
    getTopicIdsFromIndexes (indexes = this.selectedTopics) {
      let topicIds = [];
      for (let index of indexes) {
        topicIds.push(this.topics[index].id);
      }
      return topicIds;
    }
  },
  beforeDestroy () {
    this.$bus.$off('scrollList');
  },
  mounted () {
    this.$bus.$on('scrollList', ($params) => {
      if ($params.toggle) {
        let container = document.getElementById('scrollSize');
        let element = document.getElementById('topicsTabList').childNodes[$params.topicIndex];
        let cTop = container.scrollTop;
        let cBottom = cTop + container.clientHeight;
        let eTop = element.offsetTop;
        let eBottom = eTop + element.clientHeight;
        if (eTop < cTop || eBottom > cBottom) {
          container.scrollTop -= (cTop - eTop);
        } else if (eBottom > cBottom) {
          container.scrollTop += (eBottom - cBottom);
        }
      }
    });
  }
};
</script>
<style lang="scss">
.material-icons-My img {
    margin-top: 0px !important;
}

.extraClass {
    background: none;
    border: none;
    text-align: center;
    float: left;
    width: 100%;
    cursor: pointer;
    font-size: inherit;
}

.map-page .search .search-glass-icon {
    position: absolute !important;
}

.map-page .md-icon {
    height: 36px !important;
    font-size: 24px !important;
}

.map-page .search {
    margin-top: 8px !important;

    .md-input {
        width: 100% !important;
        padding-right: 36px !important;
    }
}

.map-page .search .autocomplete-buttons {
    position: absolute;
    top: 0px;
    right: 25px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    z-index: 7;
    margin: 0;
}

.map-page aside .search .md-button.md-icon-button {
    left: 0px !important;
    top: 0px !important;
}

.md-button:not([disabled])
.md-focused:before,
.md-button:not([disabled]):active:before,
.md-button:not([disabled]):hover:before {
    background-color: white !important;
    opacity: 0 !important;
}

.map-page .scroll-list {
    overflow: auto;
}

.map-page .md-list-item .avatar {
    float: left;
    margin: 14px 16px 14px 24px;
    position: relative;
}

.map-page .item-selected .avatar:before {
    color: #fff;
    background: #00a8ca;
    border-radius: 500rem;
    display: block;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 0;
    left: 0;
    border: none;
    z-index: 1;
    line-height: 36px;
    text-align: center;
    font-size: 24px;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\e5ca";
}

.map-page .item-unselected .avatar:hover:before, .items-active .item-unselected .avatar:before {
    background: #fff;
    border-radius: 500rem;
    display: block;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    border: 2px solid #00a8ca;
    content: '';
}

.map-page .md-list-item-text h3 {
    padding: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
}

.map-page .md-list-item-text p {
    padding: 0;
    color: #8c8c8c;
    line-height: 18px;
}

.map-page .md-list-item-text {
    margin: 16px 0 !important;
}

.aside-wrapper .md-list-item-content {
    padding: 0 58px 0 0 !important;
}

.map-page .item-selected, .map-page .item-unselected {
    width: 100% !important;
}

.map-page em.sub-items {
    position: absolute;
    top: 0;
    right: 0;
    width: 38px;
    height: 64px;
    line-height: 64px;
    color: #8c8c8c;
    display: block;
    font-style: normal;
    font-size: 14px;
    font-weight: 400;
}

.map-page .upload-btn {
    position: absolute;
    top: 8px;
    right: 10px;
    width: initial !important;
    // display: none;
}

.map-page .expanded-block.item-expanded {
    height: auto !important;
}

.map-page .expanded-block .sub-item {
    width: 344px !important;
}

.map-page .expanded-block .sub-item .sub-item-button {
    height: 32px;
    line-height: 32px;
    min-height: 32px;
    display: block;
    margin: 0;
    width: 100%;
    text-transform: none;
    font-weight: 400;
}

.map-page .expanded-block .sub-item .md-button-content {
    width: 100%;
    padding: 0 32px;
}

.map-page .expanded-block .sub-item .md-icon, .map-page .expanded-block .sub-item .right-item button {
    height: 32px !important;
}

/* TODO make this dynamic */
#topicsTab .scroll-list {
    position: absolute;
    top: 298px;
    bottom: 92px;
    left: 0;
    right: 0;
    overflow: auto;
    -webkit-box-shadow: 5px 0 8px -2px #888;
    -moz-box-shadow: 5px 0 8px -2px #888;
    box-shadow: 5px 0 8px -2px #888;
}

.aside-btn button {
    color: #fff !important;
}

.map-page .search .delete-btn {
    margin-left: 24px;
}

.TopicRoutesContainer .md-list-item-text {
    width: 210px;
}

hr {
    margin: 0 !important;
}

.md-menu-item .md-button {
    font-size: 14px !important;
    font-weight: 400;
    margin: 0 !important;
    line-height: 36px !important;
    text-align: left;
    text-transform: none;
}

.add-btn {
    bottom: 48px;
}

.addToRouteDialog .routeOption {
    width: 100%;
}

.disabled-button {
    background-color: #DBDBDB;
}

.checkbox {
    margin: 10px 0px 0px 15px;
    font-size: 13px;
    color: #00A8CA;
}

.checkbox-disabled {
    display: none;
}

.back-grey {
    background-color: rgb(224, 224, 224);
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.scroll-cont-wrap {
    max-height: 200px !important;
    overflow: auto !important;
}

.instruction-delete {
    font-size: 13px !important;
    padding-top: 10px !important;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TopicsTab.vue